import { useQuery } from 'react-query';
import { useContext } from 'react';
import { AuthContext } from '../../Context/AuthContext';

const fetchOtherDocuments = async (token) => {
  const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/charterer/profile/otherDocuments`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error('Failed to fetch other documents');
  }

  return response.json();
};

const useFetchOtherDocuments = () => {
  const { token } = useContext(AuthContext);

  return useQuery('otherDocuments', () => fetchOtherDocuments(token));
};

export default useFetchOtherDocuments;

